<template>
  <div class="p-3">
    <div class="">
      <h6 class="pb-4 bb-1">START MESSAGE
        <img @click='emitQuitGroup()' class="icon pull-right" src="static/assets/img/SVGIcons/icon-close-circle-blue.svg" />
      </h6>
      <form name=''>
        <div class="form-group">
          <input class='form-control' type='text' placeholder="Name your group" v-model='groupName' name='groupName'
            id='groupName' />
        </div>
        <div class="form-group">
          <span @click='removeUser(user.Id)' v-for='user in selectedUsers' :key='user.Id'>{{user.Name}}</span>
          <input ref='to' v-model='searchText' class='form-control' type='text' placeholder="To" />
        </div>
        <div>
          <ul class="list-group list-group-flush" v-if='possibleUsers && searchText.length > 3'>
            <li v-for='result in possibleUsers' :key='result.Id' class="list-group-item">
              <table class="w-100">
                <tr>
                  <td width="40px" @click='addUser(result)'>
                    <img v-if='result.AvatarUrl' :src='result.AvatarUrl' height='40px' width='40px;' />
                    <img v-else src='static/assets/img/avatar.png' height='40px' width='40px;'/>
                  </td>
                  <td class="px-3">
                    <table>
                      <tr>
                        <td @click='addUser(result)'>
                          <b class="text-primary">{{result.Name}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td>{{result.Platform}}</td>
                      </tr>
                    </table>
                  </td>
                  <td @click='addUser(result)'>
                    <img src="static/assets/img/icon-add-user-plus.png" /> </td>
                </tr>
              </table>
            </li>
          </ul>
        </div>
      </form>

      <div>
        <composer placeholder='To begin a group, please type a message...' :custom-submit='true' @composeSubmit='handleComposeSubmit($event)' 
          :hide-attachment='true'></composer>
        <div v-for='error in errors' :key='error.Message'>
          <p class='has-error'>
            {{error.Message | humanError}}
          </p>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
  import {
    MessengerAPIClient
  } from '@/lib/data_access/messenger'
  import Composer from '@/components/Messenger/Composer'
  export default {
    data() {
      return {
        possibleUsers: [],
        searchText: '',
        selectedUsers: [],
        groupName: '',
        formHasErrors: false,
        errors: []
      }
    },
    props: [
      'customerIdentifiers',
    ],
    filters: {
      humanError: function (val){
        console.log(val)
        if(val){
         let res = val.replace('Unable to Send Message:', '')
          return res;
        }
        return ''
      }
    },
    mounted(){
      let vm = this;
      let to = document.getElementById("to");
      vm.$refs.to.focus();
    },
    components: {
      Composer
    },
    watch: {
      searchText: {
        handler: function (newVal, oldVal) {
          let vm = this;
          if (newVal.length >= 3) {
            if (newVal.length < 20) {
              vm.searchUsers(newVal)
            }
          } else {
            vm.possibleUsers = [];
          }
        }
      }
    },
    methods: {
      searchUsers: function (searchText) {
        let vm = this;
        console.log(vm.$parent.user)
        let searchObj = {}
        searchObj.from = 0
        searchObj.size = 10
        searchObj.accountPlatformIds = [vm.$parent.user.AccountPlatformID]
        searchObj.orderBy = 'lastname'
        searchObj.orderDir = 'asc'
        searchObj.search = searchText
        console.log(searchText)
        MessengerAPIClient.searchUsers(searchObj).then(function (resp) {
          vm.possibleUsers = resp.results
        })
      },
      emitQuitGroup: function () {
        let vm = this;
        vm.$emit('quitcreategroup')
      },
      handleComposeSubmit: function (event) {
        // MessengerAPIClient.postCustomerGroup()
        let vm = this;
        let chatPackage = {}
        if (vm.groupName != '') {
          chatPackage.GroupName = vm.groupName;
        }
        chatPackage.UserIds = []
        vm.selectedUsers.forEach(function (user) {
          chatPackage.UserIds.push(user.Id)
        })
        chatPackage.Message = event
        chatPackage.CustomerIdentifiers = vm.customerIdentifiers


        MessengerAPIClient.postCustomerGroup(chatPackage).then(function (grpResp) {
          vm.errors = []
          vm.$emit('groupcreated', grpResp)
        }).catch(function (error) {
          vm.errors = Object.assign([], error)
        })
      },
      addUser: function (user) {
        let vm = this;
        vm.selectedUsers.push(user)
      },
      removeUser: function (userId) {
        let vm = this;
        let index = vm.selectedUsers.findIndex(function (element) {
          return element.Id == userId
        });
        vm.selectedUsers.splice(index, 1)
      }
    }
  }

</script>

<style lang="scss" scoped>
  .icon {
    height: 24px;
    width: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/CreateGroup/CreateGroup.vue